// src/modules/app-views/ticket-events/pages/Init/actions/menuButton.js
import { dropdownDivider, dropdownParameters } from 'layouts/Pages/PageHeader/dropdownMenus';

const ticketEventsInitMenuButton = () => {
  return {
    action: 'dropdownMenu',
    dropdownItems: [
      dropdownParameters,
      dropdownDivider,
    ],
  };
};

export default ticketEventsInitMenuButton;
